export const VideoCardSkeleton = ({}) => {
  return (
    <div className="card-container container-lg skeleton-container">
      <div className="skeleton-item-image skeleton"></div>
      <div className="skeleton-item-button skeleton"></div>
    </div>
  );
};
